<template>
  <div class="index-content" @click="tochangePassword">
    <div class="layout" :style="{ height: '100%', width: '100%' }" @click="tochangePassword">
      <Layout :style="{ width: '100%', height: '60px', 'font-family': 'SimHei' }">
        <Header :style="{ background: '#53CAC3', height: '60px' }">
          <Menu mode="horizontal" theme="dark" :style="{ background: '#53CAC3' }">
            <div class="layout-logo">
              <img class="logo-img" src="./img/tilogo.png" />
            </div>
            <div class="layout-nav">
              精益运营
            </div>

            <div class="logo-right" @click="tochangePassword">
              <ul>
                <li>{{ logonItem.loginName || "默认" }}</li>
                <li>{{ logonItem.position }}</li>
              </ul>
              <img class="logo-right-img" src="./img/head.png" alt="" />
              <div class="tuichu" v-show="changeTuichu">
                <Button class="btn sure" type="success" ghost @click="geGuanli(1)">账号管理</Button>
                <Button class="btn sure" v-show="noteShow" type="success" ghost @click="geGuanli(3)">管理移交</Button>
                <Button class="btn sure" type="success" ghost @click="geGuanli(2)">退出</Button>
              </div>
            </div>
          </Menu>
        </Header>
      </Layout>
      <div class="changepasswords" v-show="ischangePassword">
        <Changepassword ref="Changepassword" v-show="ischangePassword && !yijiaoShow" @changpasswordeishow="changpasswordeishow"></Changepassword>
        <Yijiao ref="Yijiao" @changpasswordeishow="changpasswordeishow" v-show="ischangePassword && yijiaoShow">
        </Yijiao>
      </div>
      <Layout class="xitongshezhi" :style="{ 'font-family': 'SimHei' }" v-show="!ischangePassword">
        <!-- 侧边栏第一个展示 -->
        <Sider hide-trigger class="sider-one" width="50" :style="{ background: '#C3C6CE' }">
          <div class="sider-first-item" :class="{ 'sider-first-item-active': item.active == firstIndex }" v-for="(item, index) in firstmu" :key="index" @click="changeFirstmu(item, index)">
            {{ item.permissionName }}
          </div>
        </Sider>

        <!-- 侧边栏第二块展示 -->
        <!-- 检中管理 -->
        <Sider v-show="this.firstIndex == 3" hide-trigger :style="{ background: '#D4D4D4', 'font-family': 'SimHei' }" width="170">
          <Menu :active-name="activeNum" theme="light" width="auto" :open-names="['0-3']">
            <Submenu v-for="(item, index) in secondemuobj2.secondmu" :key="index" :name="item.active">
              <template slot="title">
                {{ item.name }}
              </template>
              <MenuItem :class="{
                  'ivu-menu-item ivu-menu-item-active ivu-menu-item-selected':
                    activeNum == i.active
                }" v-for="(i, indexs) in item.data" :key="indexs" :name="i.active" @click.native="changeContent(i, index)">{{ i.name }}</MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <!-- 检后管理 -->
        <Sider v-show="this.firstIndex == 7" hide-trigger :style="{ background: '#D4D4D4', 'font-family': 'SimHei' }" width="170">
          <Menu :active-name="activeNum" theme="light" width="auto" :open-names="['0-3']">
            <Submenu v-for="(item, index) in secondemuobj7.secondmu" :key="index" :name="item.active">
              <template slot="title">
                {{ item.name }}
              </template>
              <MenuItem :class="{
                  'ivu-menu-item ivu-menu-item-active ivu-menu-item-selected':
                    activeNum == i.active
                }" v-for="(i, indexs) in item.data" :key="indexs" :name="i.active" @click.native="changeContent(i, index)">{{ i.name }}</MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <!-- 信息统计 -->
        <Sider v-show="this.firstIndex == 4" hide-trigger :style="{ background: '#D4D4D4' }" width="170">
          <Menu :active-name="activeNum" theme="light" width="auto" :open-names="['0-3']">
            <Submenu v-for="(item, index) in secondemuobj3.secondmu" :key="index" :name="item.active">
              <template slot="title">
                {{ item.name }}
              </template>
              <MenuItem :class="{
                  'ivu-menu-item ivu-menu-item-active ivu-menu-item-selected':
                    activeNum == i.active
                }" v-for="(i, indexs) in item.data" :key="indexs" :name="i.active" @click.native="changeContent(i, index)">{{ i.name }}</MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <!-- 财务管理 -->
        <Sider v-show="this.firstIndex == 5" hide-trigger :style="{ background: '#D4D4D4' }" width="170">
          <Menu :active-name="activeNum" theme="light" width="auto" :open-names="['0-3', '0-2']">
            <Submenu v-for="(item, index) in secondemuobj4.secondmu" :key="index" :name="item.active">
              <template slot="title">
                {{ item.name }}
              </template>
              <MenuItem :class="{
                  'ivu-menu-item ivu-menu-item-active ivu-menu-item-selected':
                    activeNum == i.active
                }" v-for="(i, indexs) in item.data" :key="indexs" :name="i.active" @click.native="changeContent(i, index)">{{ i.name }}</MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <!-- 检前管理 -->
        <Sider v-show="this.firstIndex == 2" hide-trigger :style="{ background: '#D4D4D4', 'font-family': 'SimHei' }" width="170">
          <Menu :active-name="activeNum" theme="light" width="auto" :open-names="['0-1', '0-2', '0-3']">
            <Submenu v-for="(item, index) in secondemuobj.secondmu" :key="index" :name="item.active">
              <template slot="title">
                {{ item.name }}
              </template>
              <MenuItem :class="{
                  'ivu-menu-item ivu-menu-item-active ivu-menu-item-selected':
                    activeNum == i.active
                }" v-for="(i, indexs) in item.data" :key="indexs" :name="i.active" @click.native="changeContent(i, index)">{{ i.name }}</MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <!-- 问卷管理 -->
        <Sider v-show="this.firstIndex == 6" hide-trigger :style="{ background: '#D4D4D4', 'font-family': 'SimHei' }" width="170">
          <Menu :active-name="activeNum" theme="light" width="auto" :open-names="['0-1', '0-2', '0-3']">
            <Submenu v-for="(item, index) in secondemuobj5.secondmu" :key="index" :name="item.active">
              <template slot="title">
                {{ item.name }}
              </template>
              <MenuItem :class="{
                  'ivu-menu-item ivu-menu-item-active ivu-menu-item-selected':
                    activeNum == i.active
                }" v-for="(i, indexs) in item.data" :key="indexs" :name="i.active" @click.native="changeContent(i, index)">{{ i.name }}</MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <!-- 系统设置 -->
        <Sider v-show="this.firstIndex == 1" hide-trigger :style="{ background: '#D4D4D4', 'font-family': 'SimHei' }" width="170">
          <Menu :active-name="activeNum" theme="light" width="auto" :open-names="['0-3']">
            <Submenu v-for="(item, index) in secondemuobj1.secondmu" :key="index" :name="item.active">
              <template slot="title">
                {{ item.name }}
              </template>
              <MenuItem :class="{
                  'ivu-menu-item ivu-menu-item-active ivu-menu-item-selected':
                    activeNum == i.active
                }" v-for="(i, indexs) in item.data" :key="indexs" :name="i.active" @click.native="changeContent(i, index)">{{ i.name }}</MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <Layout class="layput-top" :style="{ 'font-family': 'SimHei' }">
          <Breadcrumb class="top-tab">
            <ul class="top-tab-ul">
              <li :class="{ active: index == routerIndex }" v-for="(item, index) in routerLIst" :key="index">
                <Icon type="ios-radio-button-on" @click="changeRouterIndex(item, index)" />
                <span @click="changeRouterIndex(item, index)">{{
                  item.name
                }}</span>
                <Icon style="z-index:999" type="md-close" @click="clearItem(item)" />
              </li>
            </ul>
          </Breadcrumb>
          <Content class="top-tab-content">
            <Renwu v-if="activeNum == '0-3-1'"></Renwu>
            <Keyong v-if="activeNum == '0-4-1'"></Keyong>
            <!-- <Heimingdan v-if="activeNum == '0-3-2'"></Heimingdan> -->
            <Canxiang v-if="activeNum == '0-5-1'"></Canxiang>
            <Kongzhi v-if="activeNum == '0-5-2'"></Kongzhi>
            <Tixing v-if="activeNum == '0-5-3'"></Tixing>
            <Tuixiang v-if="activeNum == '0-5-4'"></Tuixiang>
            <Alladdxiang v-if="activeNum == '0-7-1'"></Alladdxiang>
            <Qiyeaddxiang v-if="activeNum == '0-7-2'"></Qiyeaddxiang>
            <Xianyue v-if="activeNum == '0-7-3'"></Xianyue>
            <Xiangyue v-if="activeNum == '0-7-4'"></Xiangyue>
            <Jiezhang v-if="activeNum == '0-8-1'"></Jiezhang>
            <Tijiao v-if="activeNum == '0-8-2'"></Tijiao>
            <Jisuan v-if="activeNum == '0-8-3'"></Jisuan>
            <Wenzhen v-if="activeNum == '0-6-1'"></Wenzhen>
            <Organization v-if="activeNum == '0-1-1'"></Organization>
            <Role v-if="activeNum == '0-1-2'"></Role>
            <Jurisdiction v-if="activeNum == '0-1-3'"></Jurisdiction>
            <Journal v-if="activeNum == '0-1-4'"></Journal>
            <Xitong v-if="activeNum == '0-1-5'"></Xitong>
            <Shenhe v-if="activeNum == '0-9-1'"></Shenhe>
            <Shijian v-if="activeNum == '0-5-5'"></Shijian>
            <JiHua v-if="activeNum === '0-5-6'"></JiHua>
            <Doctorpaiban v-if="activeNum === '0-12-1'"></Doctorpaiban>
            <Doctorworktongji v-if="activeNum === '0-12-2'"></Doctorworktongji>
            <Tuanti v-if="activeNum == '0-7-5'"></Tuanti>
            <Questionlist v-if="activeNum == '0-10-1'"></Questionlist>
            <Questionwei v-if="activeNum == '0-10-2'"></Questionwei>
            <Fenzu v-if="activeNum == '0-10-3'"></Fenzu>
            <Tuijian v-if="activeNum == '0-11-2'"></Tuijian>
            <Dingzhixiang v-if="activeNum == '0-10-4'"></Dingzhixiang>
            <Dajuan v-if="activeNum == '0-10-5'"></Dajuan>
            <Dingding v-if="activeNum == '0-11-3'"></Dingding>
            <QuestionsJie v-if="activeNum == '0-11-4'"></QuestionsJie>
          </Content>
        </Layout>
      </Layout>
    </div>
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>

<script>
import {
  getLoginUserInfoByToken,
  getLoginUserPerms,
  logout,
} from "./servers/api";
import Dingding from "./questions/dingDing";
import Renwu from "./yuyue/renwu";
import Keyong from "./yuyue/keyong";
// import Heimingdan from "./yuyue/heimingdan";
import Canxiang from "./yuyue/canxiang";
import Kongzhi from "./yuyue/kongzhi";
import Tixing from "./yuyue/tixing";
import Alladdxiang from "./xinxi/alladdxiang";
import Qiyeaddxiang from "./xinxi/qiyeaddxiang";
import Jiezhang from "./caiwu/jiezhang";
import Jisuan from "./caiwu/jisuan";
import Tijiao from "./caiwu/tijiao";
import Changepassword from "./changePassword";
import Tuixiang from "./yuyue/tuixiang";
import Wenzhen from "./wenzhen/wenzhen";
import Yijiao from "./yijiao";
import Organization from "./shezhi/organization";
import Role from "./shezhi/role";
import Jurisdiction from "./shezhi/jurisdiction";
import Journal from "./shezhi/Journal";
import Xitong from "./shezhi/xitong";
import Xianyue from "./xinxi/xianYue";
import Xiangyue from "./xinxi/xiangYue";
import Shenhe from "./caiwu/shenhe";
import Shijian from "./yuyue/shijian";
import Tuanti from "./xinxi/tuanti";
import Questionlist from "./questions/questionlist";
import Questionwei from "./questions/questionswei";
import Fenzu from "./questions/Fenzu";
import Tuijian from "./questions/tuijian";
import Dingzhixiang from "./questions/dingzhi";
import Dajuan from "./questions/dajuan";
import QuestionsJie from "./questions/questionsJie";
import JiHua from "./yuyue/jihua";
import Doctorpaiban from "./jianhou/doctorpaiban";
import Doctorworktongji from "./jianhou/doctorworktongji";
export default {
  name: "HelloWorld",
  data() {
    return {
      isiconfontshow: false,
      ischangePassword: false, //去改密码
      spinShow: true,
      activeNum: "",
      noteShow: false,
      firstmu: [
        {
          permissionName: "预约管理",
        },
        {
          permissionName: "检中管理",
        },
        {
          permissionName: "信息统计",
        },
        {
          permissionName: "财务管理",
        },
      ],
      firstIndex: "2", // 管理目标下标index
      secondemuobj: {
        //检前管理
        secondmu: [
          {
            name: "团检管理",
            active: "0-1",
            data: [
              {
                name: "任务管理",
                active: "",
              },
              {
                name: "团检预约黑名单",
                active: "",
              },
            ],
          },
          {
            name: "个检管理",
            active: "0-2",
            data: [
              {
                name: "可用套餐",
                active: "",
              },
            ],
          },
          {
            name: "通用管理",
            active: "0-3",
            data: [
              {
                name: "可加项列表",
                active: "",
              },
              {
                name: "预约控制",
                active: "",
              },
              {
                name: "检前提醒",
                active: "",
              },
              {
                name: "退项管理",
                active: "",
              },
            ],
          },
        ],
        num: 1,
      },
      secondemuobj5: {
        //检前管理
        secondmu: [
          {
            name: "团检管理",
            active: "0-1",
            data: [
              {
                name: "任务管理",
                active: "",
              },
              {
                name: "团检预约黑名单",
                active: "",
              },
            ],
          },
          {
            name: "个检管理",
            active: "0-2",
            data: [
              {
                name: "可用套餐",
                active: "",
              },
            ],
          },
          {
            name: "通用管理",
            active: "0-3",
            data: [
              {
                name: "可加项列表",
                active: "",
              },
              {
                name: "预约控制",
                active: "",
              },
              {
                name: "检前提醒",
                active: "",
              },
              {
                name: "退项管理",
                active: "",
              },
            ],
          },
        ],
        num: 1,
      },
      secondemuobj1: {
        //系统设置
        secondmu: [
          {
            name: "科室管理",
            active: "0-3",
            data: [
              {
                name: "问诊室",
                active: "",
              },
            ],
          },
        ],
        num: 2,
      },
      secondemuobj7: {
        //检后管理
        secondmu: [
          {
            name: "医生管理",
            active: "0-12",
            data: [
              {
                name: "医生排班",
                active: "",
              },
            ],
          },
        ],
        num: 2,
      },
      secondemuobj2: {
        //检中管理
        /*  secondmu: [
          {
            name: "科室管理",
            active: "0-3",
            data: [
              {
                name: "问诊室",
                active: "",
              },
            ],
          },
        ], */
        num: 2,
      },
      secondemuobj3: {
        //信息统计
        secondmu: [
          {
            name: "加项统计",
            active: "0-3",
            data: [
              {
                name: "全部加项信息",
                active: "",
              },
              {
                name: "企业加项信息",
                active: "",
              },
            ],
          },
        ],
        num: 2,
      },
      secondemuobj4: {
        //财务管理
        secondmu: [
          {
            name: "结算管理",
            active: "0-3",
            data: [
              {
                name: "结账单生成",
                active: "",
              },
              {
                name: "提交结算",
                active: "",
              },
              {
                name: "结算记录",
                active: "",
              },
            ],
          },
          {
            name: "结算管理",
            active: "0-2",
            data: [
              {
                name: "结账单生成",
                active: "",
              },
              {
                name: "提交结算",
                active: "",
              },
              {
                name: "结算记录",
                active: "",
              },
            ],
          },
        ],
        num: 2,
      },
      arrs: ["aaa", "aaaa", "aafa"],
      routerIndex: 0,
      routerLIst: [], //存放导航上面菜单
      logonItem: {},
      changeTuichu: false, //控制账号退出狂显示
      yijiaoShow: false,
    };
  },
  methods: {
    getLoginUserInfoByToken() {
      //获取以及菜单
      this.isiconfontshow = true;
      getLoginUserInfoByToken({}).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.firstmu = res.data.data.permissionOne;
          if (this.firstmu[0]) {
            for (let i = 0; i < this.firstmu.length; i++) {
              this.firstIndex = this.firstmu[0].active;
              this.getLoginUserPerms(this.firstmu[i], i); //机构运营
            }
          }
        } else {
          this.isiconfontshow = false;
        }
      });
    },
    getLoginUserPerms(id, index) {
      //二级菜单请求
      let params = {
        permId: id.permissionId,
      };
      this.isiconfontshow = true;
      let that = this;
      getLoginUserPerms(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.firstIndex = this.firstmu[0].active;
          switch (id.active) {
            case "2":
              this.secondemuobj.secondmu = res.data.data;
              this.routerLIst.push(this.secondemuobj.secondmu[0].data[0]);
              this.activeNum = this.routerLIst[0].active;
              break; //检前管理
            case "3":
              this.secondemuobj2.secondmu = res.data.data;
              break; //检中管理
            case "4":
              this.secondemuobj3.secondmu = res.data.data;
              break; //信息统计
            case "5":
              this.secondemuobj4.secondmu = res.data.data;
              break; //财务管理
            case "1":
              this.secondemuobj1.secondmu = res.data.data;
              break; //系统设置
            case "6":
              this.secondemuobj5.secondmu = res.data.data;
              break; //问卷管理
            case "7":
              this.secondemuobj7.secondmu = res.data.data;
              break; //检后管理
          }
        } else {
          this.isiconfontshow = false;
        }
      });
    },
    clearItem(item) {
      //删除顶部菜单
      if (this.routerLIst.length > 1) {
        let index = this.routerLIst.indexOf(item);
        index > -1 && this.routerLIst.splice(index, 1);
        this.changeRouterIndex(
          this.routerLIst[0],
          0,
          this.routerLIst[0].active
        );
      }
    },
    changeRouterIndex(item, index, active) {
      //顶部菜单栏跳转切换
      this.routerIndex = index; //路由高亮
      this.activeNum = active || item.active;
      switch (
        item.active //通过active判断是哪页
      ) {
        case "0-3-1":
          this.firstIndex = 2;
          break; //检前管理-任务管理
        // case "0-3-2":
        //   this.firstIndex = 2;
        //   break; //检前管理-团检预约黑名单
        case "0-4-1":
          this.firstIndex = 2;
          break; //检前管理-可用套餐
        case "0-5-1":
          this.firstIndex = 2;
          break; //检前管理-可加项列表
        case "0-5-2":
          this.firstIndex = 2;
          break; //检前管理-预约控制
        case "0-5-3":
          this.firstIndex = 2;
          break; //检前管理-检前提醒
        case "0-5-4":
          this.firstIndex = 2;
          break; //检前管理-退项管理
        case "0-5-5":
          this.firstIndex = 2;
          break; //检前管理-预约时段控制
        case "0-5-6":
          this.firstIndex = 2;
          break; //检前管理-预约计划

        case "0-6-1":
          this.firstIndex = 3;
          break; //科室管理-问诊室

        case "0-7-1":
          this.firstIndex = 4;
          break; //信息统计-全部加项信息
        case "0-7-2":
          this.firstIndex = 4;
          break; //信息统计-企业加项信息
        case "0-7-3":
          this.firstIndex = 4;
          break; //信息统计-线上预约统计
        case "0-7-4":
          this.firstIndex = 4;
          break; //信息统计-收费项统计
        case "0-7-5":
          this.firstIndex = 4;
          break; //信息统计-团体预约统计

        case "0-8-1":
          this.firstIndex = 5;
          break; //财务管理-结账单生成
        case "0-8-2":
          this.firstIndex = 5;
          break; //财务管理-结算提交"
        case "0-8-3":
          this.firstIndex = 5;
          break; //财务管理-结算记录
        case "0-9-1":
          this.firstIndex = 5;
          break; //财务管理-退款审核

        case "0-1-2":
          this.firstIndex = 1;
          break; //系统设置-角色管理
        case "0-1-1":
          this.firstIndex = 1;
          break; //系统设置-组织架构
        case "0-1-3":
          this.firstIndex = 1;
          break; //系统设置-权限分配
        case "0-1-4":
          this.firstIndex = 1;
          break; //系统设置-操作日志
        case "0-10-1":
          this.firstIndex = 6;
          break; //问卷管理-问卷列表
        case "0-10-2":
          this.firstIndex = 6;
          break; //问卷管理-问题维护
        case "0-10-3":
          this.firstIndex = 6;
          break; //问卷管理-分组维护
        case "0-10-4":
          this.firstIndex = 6;
          break; //问卷管理-项目推荐
        case "0-10-5":
          this.firstIndex = 6;
          break; //问卷管理-项目推荐
        case "0-11-1":
          this.firstIndex = 6;
          break; //问卷管理-定制项目列表
        case "0-11-2":
          this.firstIndex = 6;
          break; //问卷管理-推荐依据
        case "0-11-3":
          this.firstIndex = 6;
          break; //问卷管理-定制订单
        case "0-11-4":
          this.firstIndex = 6;
          break; //问卷管理-问卷介绍
      }
    },

    changeContent(item, idex) {
      //二级菜单栏
      this.activeNum = item.active;
      let it = item.active;
      let num = -1;
      for (let i = 0; i < this.routerLIst.length; i++) {
        if (this.routerLIst[i].active == it) {
          num = i;
        }
      }
      num > -1 && this.routerLIst.splice(num, 1);
      this.routerLIst.unshift(item);
      this.routerIndex = 0;
      this.tochangePassword();
    },
    tofenlei(item) {
      //收费项美化点击跳转过来
      // this.changeContent({
      //   active: "0-4-2",
      //   name: "收费项分类",
      //   selected: false
      // })
      // this.firstIndex=2;
    },
    geGuanli(index) {
      //点击账号管理
      if (index == 2) {
        //退出
        this.isiconfontshow = true;
        logout({}).then((res) => {
          if (res.data.code == 1) {
            this.isiconfontshow = false;
            this.$router.push({
              name: "login",
            });
          }
        });
      } else if (index == 3) {
        //移交
        this.ischangePassword = true;
        this.yijiaoShow = true;
        this.$refs.Yijiao.gopass();
      } else {
        this.ischangePassword = true;
        this.yijiaoShow = false;
        this.$refs.Changepassword.gopass();
      }
    },
    changeFirstmu(name, index) {
      //切换左侧管理类目录表
      this.firstIndex = name.active;
      switch (name.active) {
        case "2":
          this.selectActiveList(this.secondemuobj.secondmu[0].data);
          break; //检前管理
        case "3":
          this.selectActiveList(this.secondemuobj2.secondmu[0].data);
          break; //检中管理
        case "4":
          this.selectActiveList(this.secondemuobj3.secondmu[0].data);
          break; //信息管理
        case "5":
          this.selectActiveList(this.secondemuobj4.secondmu[0].data);
          break; //财务管理
        case "1":
          this.selectActiveList(this.secondemuobj1.secondmu[0].data);
          break; //系统设置
        case "6":
          this.selectActiveList(this.secondemuobj5.secondmu[0].data);
          break; //问卷管理
        case "7":
          this.selectActiveList(this.secondemuobj7.secondmu[0].data);
          break; //检后管理
      }
    },
    selectActiveList(list) {
      //点击左侧一级菜单显示首个页面
      let num = 0;
      for (let i = 0; i < this.routerLIst.length; i++) {
        if (this.routerLIst[i].active == this.activeNum) {
          //路由里面有当前点击得一级菜单得首个页面
          num = i;
        }
      }
      if (num > 0) {
        this.routerLIst.splice(num, 1);
        this.routerLIst.unshift(list[0]);
      } else {
        this.routerLIst.unshift(list[0]);
      }
      this.activeNum = this.routerLIst[0].active;
    },
    toyemian() {
      //页面
      this.$router.push({
        name: "yemian",
        params: {
          aa: 1,
        },
      });
    },
    getLogin() {
      //获取登录信息
      this.logonItem = JSON.parse(sessionStorage.getItem("login")) || {};
      this.getLoginUserInfoByToken();
    },
    changpasswordeishow(item) {
      //接受改密得方法
      this.ischangePassword = item;
    },
    tochangePassword(e) {
      //去改密码
      if (e && e.stopPropagation) {
        //阻止事件冒泡
        e.stopPropagation();
      } else {
        window.event.cancelBubble = true;
      }
      if (e && e.target && e.target.className == "logo-right-img") {
        this.changeTuichu = !this.changeTuichu;
      } else {
        this.changeTuichu = false;
      }
    },
  },
  components: {
    QuestionsJie,
    Dajuan,
    Dingzhixiang,
    Tuijian,
    Fenzu,
    Questionwei,
    Questionlist,
    Tuanti,
    Renwu,
    Keyong,
    // Heimingdan,
    Canxiang,
    Kongzhi,
    Tixing,
    Alladdxiang,
    Qiyeaddxiang,
    Jiezhang,
    Jisuan,
    Tijiao,
    Yijiao,
    Changepassword,
    Tuixiang,
    Wenzhen,
    Organization,
    Role,
    Jurisdiction,
    Journal,
    Xitong,
    Xianyue,
    Xiangyue,
    Shenhe,
    Shijian,
    Dingding,
    JiHua,
    Doctorpaiban,
    Doctorworktongji,
  },
  created: function () {
    if (
      sessionStorage.getItem("login") &&
      JSON.parse(sessionStorage.getItem("login")).note == 1
    ) {
      this.noteShow = true;
    }
    this.getLogin();
  },
};
</script>

<style lang="scss" scoped="" type="text/css">
@import "./css/conmmon.scss";
@import "./font/iconfont.css";
.changepasswords {
  position: absolute;
  height: calc(100% - 60px);
  width: 100%;
  overflow: hidden;
  overflow-y: visible;
  padding-bottom: 30px;
}

.xitongshezhi {
  width: 100%;
  height: calc(100% - 60px);
}

.index-content {
  height: 100%;
  font-size: 13px;
  font-family: SimHei;
  overflow: hidden;
  .index-content .layout-nav .ivu-layout-header.ivu-menu-horizontal {
    background: #53cac3;
  }
  .top-tab {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }
  .top-tab-content {
    height: calc(100% - 50px);
    overflow: hidden;
    background: #fff;
    width: 100%;
    // margin-top: 50px;
  }
  .top-tab-ul {
    display: block;
    height: 50px;
    padding-top: 10px;
    font-size: 16px;
    padding-left: 10px;
    border-bottom: 1px solid #d7d7d7;
    li {
      cursor: pointer;
      margin-right: 10px;
      display: inline-block;
      background: #ffff;
      padding: 5px 5px;
      border: 1px solid #d7d7d7;
      height: 30px;
      color: #7f7f7f;
      border-radius: 5px;
      padding: 0px 10px;
      span {
        display: inline-block;
        height: 100%;
        font-size: 13px;
        line-height: 20px;
        vertical-align: bottom;
        padding: 5px;
      }
    }
    .active {
      border-color: #53cac3;
      color: #53cac3;
    }
  }
  // 头部样式
  .ivu-menu-horizontal {
    color: #fff;
  }
  // 左侧测边框
  .layout {
    height: 100%;
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    font-size: 16px;
    font-family: SimHei;
    .sider-one {
      background: #c3c6ce;
    }
    .sider-first-item {
      cursor: pointer;
      text-align: center;
      width: 50px;
      height: 70px;
      padding-left: 5px;
      padding-top: 10px;
      color: #fff;
      border-bottom: 1px solid #fff;
    }
    .sider-first-item-active {
      background: #53cac3;
      color: #7f7f7f;
      text-align: center;
    }
    .sider-first-item-buttom {
      position: absolute;
      bottom: 0;
    }
    .logo-right {
      float: right;
      height: 60px;
      margin-right: 20px;
      text-align: right;
      cursor: pointer;
      position: relative;
      .tuichu {
        position: absolute;
        background: #fff;
        border: 1px solid #53cac3;
        border-radius: 10px;
        z-index: 99;
        top: 56px;
        padding: 15px;
        padding-top: 0;
        left: 20px;
        .sure {
          background: #53cac3;
          color: #fff;
          display: block;
          margin-top: 15px;
          width: 80px;
        }
      }
      ul {
        display: block;
        height: 60px;
        float: left;
        font-size: 16p;
        margin-right: 10px;
        li {
          display: block;
          height: 30px;
          line-height: 30px;
        }
        li:first-child {
          font-size: 20px;
          padding-top: 5px;
        }
      }
      .logo-right-img {
        width: 50px;
        height: 50px;
        margin-top: 5px;
      }
    }
    // 侧边栏二级选中后
    .ivu-menu-light.ivu-menu-vertical
      .ivu-menu-item-active:not(.ivu-menu-submenu) {
      background: #53cac3;
      color: #7f7f7f;
    }
  }
  .layout-logo {
    height: 46px;
    width: 111px;
    color: #fff;
    border-radius: 3px;
    float: left;
    position: relative;
    margin-top: 7px;
    margin-left: 15px;
    .logo-img {
      width: 100%;
      height: 100%;
    }
  }
  .layout-nav {
    margin-left: 30px;
    float: left;
    font-size: 26px;
  }
  // 侧边栏第二块 里面颜色覆盖
  .ivu-menu-child-item-active .ivu-menu-submenu {
    background: red;
  }
  // 二级菜单栏选中边框
  .ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    background: #53cac3;
  }
  .ivu-layout-sider-children .ivu-menu-submenu,
  .ivu-menu-item-active,
  .ivu-menu-opened,
  .ivu-menu-child-item-active,
  .ivu-menu-vertical .ivu-menu-item,
  .ivu-menu-vertical .ivu-menu-submenu-title {
    background: #d4d4d4;
    border-bottom: 1px solid #fff;
  }
  .ivu-menu-submenu .ivu-menu .ivu-menu-item:last-child {
    border: none;
  }
  .ivu-menu-vertical .ivu-menu-item {
    border-bottom: 1px solid #fff;
  }
  .ivu-layout-sider .ivu-menu-item[data-v-47323bf2]:first-child {
    border-top: 1px solid #fff;
  }
  // .ivu-menu-vertical .ivu-menu-item-selected {
  //   // border-bottom: 1px solid #D4D4D4;
  // }
  .ivu-layout-sider .ivu-menu-vertical,
  .ivu-menu-item,
  .ivu-menu-opened,
  .ivu-menu-child-item-active {
    font-size: 16px;
    color: #7f7f7f;
  }
  .layput-top {
    padding: 0;
    height: 100%;
    width: calc(100% - 220px);
    .ivu-breadcrumb {
      height: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue